export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// Centralized route configuration - single source of truth
export const ROUTES = {
  DASHBOARD: '/dashboard',
  REPORTS_ALL: '/reports-and-analysis/all',
  ACTIVITIES_ALL: '/activities/all',
  WORKFLOWS: '/workflows',
  CAPABILITIES: '/capabilities',
  CAPABILITIES_EDIT: '/capabilities/edit',
  MFR_CREATE: '/reports-and-analysis/mfr/create',
  MFR_VIEW: '/reports-and-analysis/mfr/view',
  MFR_EDIT: '/reports-and-analysis/mfr/edit/:id',
  NETPPM_CREATE: '/reports-and-analysis/net-ppm/create',
  NETPPM_VIEW: '/reports-and-analysis/net-ppm/view',
  NETPPM_EDIT: '/reports-and-analysis/net-ppm/edit',
  RVM_CREATE: '/reports-and-analysis/rvm/create',
  RVM_VIEW: '/reports-and-analysis/rvm/view',
  RVM_EDIT: '/reports-and-analysis/rvm/edit',
  OPEX_CREATE: '/reports-and-analysis/opex/create',
  OPEX_VIEW: '/reports-and-analysis/opex/view',
  OPEX_EDIT: '/reports-and-analysis/opex/edit'
} as const;
